export const CHAMPION_SHIRT_PATH = '/store/championship/products/464';

export const images = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/1a0979da-458a-4b44-9dc6-b3d78ed40774.jpg',
  championShirt: 'https://cdn.magicpatterns.com/patterns/generated-images/bcab7387-578a-4242-bcb5-22f39a1e02ae.jpg',
};

export const primaryNav = [
  { label: 'Home', to: '/', hasMenu: false },
  { label: 'Programs', to: '/', hasMenu: true },
  { label: 'Coaches', to: '/', hasMenu: true },
  { label: 'Store', to: CHAMPION_SHIRT_PATH, hasMenu: true },
  { label: 'Blog', to: '/', hasMenu: false },
  { label: 'About Us', to: '/', hasMenu: true },
  { label: 'Contact', to: '/', hasMenu: true },
];

export const footerColumns = [
  { title: 'Follow Us', links: ['Facebook', 'Instagram', 'YouTube'] },
  { title: 'About', links: ['Our Story', 'Careers', 'Press'] },
  { title: 'Parents', links: ['Find a Program', 'FAQs', 'Safety'] },
  { title: 'Coaches', links: ['Volunteer', 'Coaching Resources'] },
  { title: 'Store Categories', links: ['Apparel', 'Equipment', 'Gift Cards'] },
  { title: 'Contact Us', links: ['Support', 'Franchise Inquiries'] },
];

export const bannerConfetti = [
  { left: '2%', top: '22%', color: '#F6B931', rotate: 20, size: 7 },
  { left: '5%', top: '70%', color: '#38B1F2', rotate: 45, size: 6 },
  { left: '28%', top: '14%', color: '#FFFFFF', rotate: 10, size: 4 },
  { left: '46%', top: '78%', color: '#EE2B24', rotate: 60, size: 6 },
  { left: '61%', top: '18%', color: '#F6B931', rotate: 35, size: 6 },
  { left: '74%', top: '72%', color: '#FFFFFF', rotate: 0, size: 4 },
  { left: '86%', top: '20%', color: '#38B1F2', rotate: 25, size: 6 },
  { left: '95%', top: '66%', color: '#F6B931', rotate: 50, size: 7 },
];

export const shirtSizes = [
  'Youth Medium',
  'Youth Large',
  'Adult Small',
  'Adult Medium',
  'Adult Large',
  'Adult X-Large',
  'Adult 2XL',
  'Adult 3XL',
];

export const storeCategories = [
  { label: 'Uniform Bottoms', hasMenu: true },
  { label: 'Bundles', hasMenu: true },
  { label: 'Shop By Sport', hasMenu: true },
  { label: "Women's Apparel", hasMenu: false },
  { label: "Men's Apparel", hasMenu: false },
  { label: 'Unisex Apparel', hasMenu: false },
  { label: "Children's Apparel", hasMenu: false },
  { label: 'Socks, Hats, Bags & More', hasMenu: false },
  { label: 'Athletic Gear', hasMenu: false },
  { label: 'Coach Store', hasMenu: false },
  { label: 'Referee Store', hasMenu: false },
  { label: 'Clearance', hasMenu: false },
  { label: 'Championship', hasMenu: false },
];

export const storePromos = [
  { title: 'Complete the Look', body: 'Grab reversible shorts for every game day!', icon: 'shirt' },
  { title: 'Fast Delivery', body: 'Get your order quickly, right to your doorstep', icon: 'truck' },
  { title: 'Be Their #1 Fan', body: 'Grab your fan gear today', icon: 'heart' },
] as const;

export const dashboardPanels = [
  { title: 'Latest Messages', body: 'There are no messages for your current program.' },
  { title: 'Coaches', body: 'Sorry, a coach has not been assigned to you yet.' },
  { title: 'Standings', body: 'Standings will appear once games have been played.' },
];
